import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    QuoteRequestTemplateDTORuntype,
    QuoteRequestTemplateInputDTORuntype,
} from './quoteRequestTemplateBackendTypes';

export const quoteRequestTemplateEndpoints = {
    'GET /quote-request/template': endpoint({
        description: 'Retrieve a list of quote request templates',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(QuoteRequestTemplateDTORuntype),
    }),
    'POST /quote-request/template': endpoint({
        description: 'Create a new quote request template',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: QuoteRequestTemplateInputDTORuntype,
        responseBody: QuoteRequestTemplateDTORuntype,
        invalidates: ['GET /quote-request/template'],
    }),
    'GET /quote-request/template/:id': endpoint({
        description: 'Retrieve a single quote request template',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: QuoteRequestTemplateDTORuntype,
    }),
    'PATCH /quote-request/template/:id': endpoint({
        description: 'Edit a quote request template',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: QuoteRequestTemplateInputDTORuntype,
        responseBody: z.string(),
        invalidates: ['GET /quote-request/template', 'GET /quote-request/template/:id'],
    }),
    'DELETE /quote-request/template/:id': endpoint({
        description: 'Delete a quote request template',
        pathParams: z.object({
            id: z.string().uuid(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.string(),
        invalidates: ['GET /quote-request/template'],
    }),
};
